module.exports = __webpack_public_path__ + "img/edit.e789fb12.svg";